import React from 'react';

const FlexController = ({ 
  isFlexHeightFixed, setFlexHeightFixed,
  isFlexItemFixed, setFlexItemFixed,
  dispatch 
}) => {

  return (
    <div className="form-controller d-flex jc-sb ai-c">

      <div className="pl-4 d-flex">
        {/* ------------------------ Flex Container Height start-------------------------------------- */}

        <div className="custom-green-checkbox d-flex ai-c jc-c mr-4">
          <input type="checkbox" id="foo1"
            checked={isFlexHeightFixed}
            onChange={() => setFlexHeightFixed(!isFlexHeightFixed)}
          />

          <label htmlFor="foo1"><span style={{ fontSize: '.7rem' }}>Fixed Height <span style={{ fontSize: '.5rem' }}>(Flex Container)</span></span></label>

        </div>
        {/* ------------------------ Flex Container Height end-------------------------------------- */}


        {/* ------------------------ Flex Item Height/Width -------------------------------------- */}

        <div className="custom-green-checkbox d-flex ai-c jc-c">
          <input type="checkbox" id="foo2"
            checked={isFlexItemFixed}
            onChange={() => setFlexItemFixed(!isFlexItemFixed)}
          />

          <label htmlFor="foo2"><span style={{ fontSize: '.7rem' }}>Fixed H-W <span style={{ fontSize: '.5rem' }}>(Flex Items)</span></span></label>

        </div>

      </div>








      <div className="pr-3">
        <button
          className="btn bg-success"
          onClick={() => dispatch({
            type: 'FLEX-ITEM-ADD'
          })}
        >+</button>

        <button
          className="btn bg-danger"
          onClick={() => dispatch({
            type: 'FLEX-ITEM-REMOVE'
          })}
        >-</button>

        <button
          className="btn bg-warning reset-btn"
          onClick={() => dispatch({
            type: 'FLEX-ITEM-RESET'
          })}
        >R</button>
      </div>

    </div>
  );
}

export default FlexController;